import { render, staticRenderFns } from "./RmOrderItemLabelPopUp.vue?vue&type=template&id=ac4ca52c&scoped=true&"
import script from "./RmOrderItemLabelPopUp.vue?vue&type=script&lang=js&"
export * from "./RmOrderItemLabelPopUp.vue?vue&type=script&lang=js&"
import style0 from "./RmOrderItemLabelPopUp.vue?vue&type=style&index=0&id=ac4ca52c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4ca52c",
  null
  
)

export default component.exports